import { API_URL } from '../../../constants';
import makeUrl from '../../utils/makeUrl';
import _fetch from '../../_fetch';

export default function fetchStatistics(options = {}) {
  return function withContext(context) {
    const url = makeUrl(API_URL, 'ndes/statistics', options);

    const config = {
      method: 'GET',
      headers: {
        'Accept': 'application/json;charset=utf-8'
      },
      ...options.reqConfig
    };

    return _fetch(url, {
      withAuth: false,
      ...options
    }, config)(context);
  };
}
